import { type UserAccount } from '@app/client';
import { USER_ROLE_ADMIN, USER_ROLE_SUPER } from '@app/store/types/user';

export class User {
    user: UserAccount | undefined | null;

    constructor(userAccount: UserAccount | null) {
        this.setState(userAccount);
    }

    setState(userAccount: UserAccount | undefined | null) {
        this.user = userAccount;
    }

    get isAdmin() {
        return !!(this.user && (this.user.role === USER_ROLE_ADMIN || this.user.role === USER_ROLE_SUPER));
    }

    get createdAt() {
        return this.user && this.user.user?.created_at ? new Date(this.user.user?.created_at) : null;
    }

    get email() {
        return this.user && this.user.user.email ? this.user.user.email : null;
    }
}
